import styled from 'styled-components';

export const WarningContainer = styled('div')`
  width: 100%;
  margin-bottom: 16px;

  .MuiAlert-root {
    font-size: 16px;
    font-weight: 500;
    justify-content: center;
  }

  @media only screen and (max-width: 1024px) {
    padding: 0 10px;

    .MuiAlert-root {
      font-size: 14px;
    }
  }
`;
